import React from 'react';
import Dashboard from './Dashboard';

function AnalyzeTabs() {
    return <Dashboard />;
}

export default React.memo(AnalyzeTabs);
